<!--
  选择优惠券
  lovi 2020-07-02
-->
<template>
  <div class="w100 childRoute-wrapper">
    <van-nav-bar
      :title="$t('coupon.coupon')"
      :fixed="true"
      left-arrow
      @click-left="navBarBack"
    />
    <div class="scroll-wrapper">
      <scroll>
        <div class="coupon">
          <div class="title" v-if="cashback.length">
            {{ $t("coupon.cashback") }}
          </div>
          <van-checkbox-group v-model="curCashbackId">
            <div
              class="item"
              :class="{ disabled: item.usable == 0 }"
              v-for="(item, index) in cashback"
              :key="index"
              @click="clickCashback(item, index)"
            >
              <div
                class="classify"
                :class="item.coupon_user_type == 1 ? 'platform' : 'merchant'"
              >
                <img
                  v-if="item.coupon_user_type == 1"
                  :src="
                    require('@/assets/images/life/coupon_platform_' +
                      (language == 'en' ? 'en' : 'cn') +
                      '@2x.png')
                  "
                />
                <img
                  v-else
                  :src="
                    require('@/assets/images/life/coupon_merchant_' +
                      (language == 'en' ? 'en' : 'cn') +
                      '@2x.png')
                  "
                />
              </div>
              <div class="info">
                <div class="info-l">
                  <h3
                    :class="item.coupon_type == 2 ? 'text-orange' : 'text-red'"
                  >
                    {{ item.money }}P
                  </h3>
                  <p>{{ item.odds }}</p>
                </div>
                <div class="info-c">
                  <h3>{{ item.coupon_name }}</h3>
                  <p>
                    <span
                      class="ticket"
                      :class="item.coupon_type == 2 ? 'style2' : 'style1'"
                    >
                      {{
                        item.coupon_type == 2
                          ? $t("coupon.voucher")
                          : $t("coupon.cashback")
                      }}
                    </span>
                    <span>{{ item.end_time }}</span>
                  </p>
                </div>
                <div class="info-r">
                  <van-checkbox
                    ref="checkboxes"
                    checked-color="#FE7800"
                    :name="item.id"
                    :disabled="item.usable ? false : true"
                  />
                </div>
              </div>
              <div class="desc text-gray">{{ item.tips }}</div>
            </div>
          </van-checkbox-group>
          <div class="title" v-if="voucher.length">
            {{ $t("coupon.voucher") }}
          </div>
          <van-radio-group v-model="curVoucherId">
            <div
              class="item"
              :class="{ disabled: item.usable == 0 }"
              v-for="(item, index) in voucher"
              :key="index"
              @click="clickVoucher(item)"
            >
              <div
                class="classify"
                :class="item.coupon_user_type == 1 ? 'platform' : 'merchant'"
              >
                <img
                  v-if="item.coupon_user_type == 1"
                  :src="
                    require('@/assets/images/life/coupon_platform_' +
                      (language == 'en' ? 'en' : 'cn') +
                      '@2x.png')
                  "
                />
                <img
                  v-else
                  :src="
                    require('@/assets/images/life/coupon_merchant_' +
                      (language == 'en' ? 'en' : 'cn') +
                      '@2x.png')
                  "
                />
              </div>
              <div class="info">
                <div class="info-l">
                  <h3
                    :class="item.coupon_type == 2 ? 'text-orange' : 'text-red'"
                  >
                    {{ item.money }}P
                  </h3>
                  <p>{{ item.odds }}</p>
                </div>
                <div class="info-c">
                  <h3>{{ item.coupon_name }}</h3>
                  <p>
                    <span
                      class="ticket"
                      :class="item.coupon_type == 2 ? 'style2' : 'style1'"
                    >
                      {{
                        item.coupon_type == 2
                          ? $t("coupon.voucher")
                          : $t("coupon.cashback")
                      }}
                    </span>
                    <span>{{ item.end_time }}</span>
                  </p>
                </div>
                <div class="info-r">
                  <van-radio
                    checked-color="#FE7800"
                    :name="item.id"
                    :disabled="item.usable ? false : true"
                  />
                </div>
              </div>
              <div class="desc text-gray">{{ item.tips }}</div>
            </div>
          </van-radio-group>
        </div>
      </scroll>
    </div>
    <div class="button-wrap button-fixed">
      <van-button
        block
        type="primary"
        @click="submit"
        v-if="cashback.length || voucher.length"
      >
        {{ $t("common.confirm") }}
        <template v-if="couponAmount">
          ({{ $t("coupon.canSave") }} {{ couponAmount.toFixed(2) }}P)
        </template>
      </van-button>
      <van-button block type="primary" disabled v-else>
        {{ $t("coupon.unavailable") }}
      </van-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: ["coupon", "cashbackId", "voucherId"],
  components: {},
  data() {
    return {
      cashback: [],
      voucher: [],

      curCashbackId: [],
      curVoucherId: "",
      curVoucher: {}, // 当前代金券
      usableList: []
    };
  },
  created() {
    let vm = this;
    vm.cashback = vm.coupon.cashback;
    vm.curCashbackId = JSON.parse(JSON.stringify(vm.cashbackId));
    let cashback = JSON.parse(JSON.stringify(vm.coupon.cashback));
    if (vm.curCashbackId.length == 1) {
      vm.couponDispose();
    }
    if (vm.curCashbackId.length == 2) {
      for (let i = 0; i < cashback.length; i++) {
        let obj = cashback[i];
        obj.usable = 0;
        for (let key of vm.curCashbackId) {
          if (key == obj.id) {
            obj.usable = 1;
          }
        }
        vm.$set(cashback, i, obj);
      }
      vm.cashback = cashback;
      console.log("curCashbackId.length == 2", vm.cashback);
    }
    vm.voucher = vm.coupon.voucher;
    vm.curVoucherId = JSON.parse(JSON.stringify(vm.voucherId));
    for (let key of vm.voucher) {
      if (key.id == vm.curVoucherId) {
        vm.curVoucher = key;
      }
    }
    console.log("cashback", vm.curCashbackId);
    console.log("voucher", vm.curVoucherId, vm.curVoucher);
  },
  mounted() {},
  computed: {
    ...mapGetters(["language"]),
    couponAmount() {
      // 优惠券金额
      let vm = this;
      let voucherMoney = 0;
      for (let key of vm.voucher) {
        if (vm.curVoucherId == key.id) {
          voucherMoney = Number(key.money);
        }
      }
      let cashbackMoney = 0;
      for (let key of vm.cashback) {
        for (let id of vm.curCashbackId) {
          if (id == key.id) {
            cashbackMoney += Number(key.money);
          }
        }
      }
      return voucherMoney + cashbackMoney;
    }
  },
  methods: {
    navBarBack() {
      // 返回事件
      this.$emit("update:couponFlag", false);
    },
    clickCashback(data, index) {
      // 点击满减券
      console.log("clickCashback", index, data);
      let vm = this;
      if (data.usable == 0) {
        return;
      }
      let cashback = JSON.parse(JSON.stringify(vm.coupon.cashback));
      let flag = true;
      for (let i = 0; i < vm.curCashbackId.length; i++) {
        if (vm.curCashbackId[i] == data.id) {
          flag = false;
          vm.curCashbackId.splice(i, 1);
          console.log("splice：", vm.curCashbackId);
          if (!vm.curCashbackId.length) {
            // 没选任何满减券
            vm.cashback = cashback;
            console.log("curCashbackId.length == 0", vm.cashback);
            return;
          }
        }
      }
      if (flag) {
        vm.curCashbackId.push(data.id);
        console.log("push：", vm.curCashbackId);
      }
      if (vm.curCashbackId.length == 1) {
        vm.couponDispose();
      }
      if (vm.curCashbackId.length == 2) {
        for (let i = 0; i < cashback.length; i++) {
          let obj = cashback[i];
          obj.usable = 0;
          for (let key of vm.curCashbackId) {
            if (key == obj.id) {
              obj.usable = 1;
            }
          }
          vm.$set(cashback, i, obj);
        }
        vm.cashback = cashback;
        console.log("curCashbackId.length == 2", vm.cashback);
      }
    },
    couponDispose() {
      // 优惠券处理
      let vm = this;
      let cashback = JSON.parse(JSON.stringify(vm.coupon.cashback));
      let type1_23 = []; //平台券 - 与商家满减券同享、与商家满减活动同享
      let type1_2 = []; //平台券 - 与商家满减券同享
      let type1_3 = []; //平台券 - 与商家满减活动同享
      let type2_04 = []; //商家券 - 与满减活动同享
      let type2_0 = []; //商家券 - 不与满减活动同享
      let cashbackList = [];
      let current = {};
      for (let key of cashback) {
        if (key.usable == 1) {
          if (key.coupon_user_type == 1) {
            //平台券
            if (key.offer_type != 1) {
              //与商家满减券同享、与商家满减活动同享
              type1_23.push(key.id);
            }
            if (key.offer_type.indexOf("2") != -1) {
              //与商家满减券同享
              type1_2.push(key.id);
            }
            if (key.offer_type.indexOf("3") != -1) {
              //与商家满减活动同享
              type1_3.push(key.id);
            }
          } else {
            //商家券
            type2_04.push(key.id);
            if (key.offer_type != 4) {
              // 与满减活动同享
              type2_0.push(key.id);
            }
          }
        }
        if (vm.curCashbackId[0] == key.id) {
          current = key;
        }
        let obj = key;
        obj.usable = 0;
        cashbackList.push(obj);
      }
      console.log("type1_23", type1_23);
      console.log("type1_2", type1_2);
      console.log("type1_3", type1_3);
      console.log("type2_04", type2_04);
      console.log("type2_0", type2_0);
      let typeList = [];
      if (current.coupon_user_type == 1) {
        // 当前优惠券 - 平台券
        if (current.offer_type.indexOf("2") != -1 && type2_04.length) {
          // 与商家满减券同享
          typeList = type2_04;
        }
        if (current.offer_type.indexOf("3") != -1 && type2_0.length) {
          // 与商家满减活动同享
          typeList = type2_0;
        }
        if (current.offer_type.indexOf("2,3") != -1 && type2_04.length) {
          // 与商家满减券同享、与商家满减活动同享
          typeList = type2_04;
        }
      } else {
        // 默认选中第一张优惠券 - 商家券
        if (current.offer_type == 0 && type1_23.length) {
          // 与满减活动同享
          typeList = type1_23;
        } else if (current.offer_type == 4 && type1_2.length) {
          // 不与满减活动同享
          typeList = type1_2;
        }
      }

      for (let i = 0; i < cashbackList.length; i++) {
        let obj = cashbackList[i];
        if (current.id == obj.id) {
          obj.usable = 1;
          vm.$set(cashbackList, i, obj);
        }
        for (let id of typeList) {
          if (id == obj.id) {
            obj.usable = 1;
            vm.$set(cashbackList, i, obj);
          }
        }
      }
      vm.cashback = cashbackList;
      console.log("curCashbackId.length == 1", vm.cashback);
    },
    clickVoucher(data) {
      // 点击代金券
      let vm = this;
      if (vm.curVoucher.id == data.id) {
        vm.curVoucherId = "";
        vm.curVoucher = {};
        console.log("curVoucherId", vm.curVoucherId, vm.curVoucher);
        return;
      }
      vm.curVoucherId = data.id;
      vm.curVoucher = data;
      console.log("curVoucherId", vm.curVoucherId, vm.curVoucher);
    },
    submit() {
      // 确认
      console.log("submit", this.curCashbackId, this.curVoucherId);
      this.$emit("update:cashbackId", this.curCashbackId);
      this.$emit("update:voucherId", this.curVoucherId);
      this.$emit("update:couponFlag", false);
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
.scroll-wrapper {
  background: #f4f4f4;
  bottom: 65px;
  .coupon {
    padding: 1.1px 0;
  }
}
.button-fixed {
  background: #f4f4f4;
}

.title {
  margin: 10px;
  font-size: 14px;
  line-height: 1.2;
}
.item {
  position: relative;
  margin: 10px;
  padding: 0 15px;
  background: #fff;
  box-shadow: 0px 0px 4px 0px rgba(221, 221, 221, 0.5);
  border-radius: 4px;
  overflow: hidden;
  &.disabled {
    .info,
    .text-red,
    .text-orange,
    .ticket {
      color: #cdcdcd;
    }
    .ticket {
      border-color: #cdcdcd;
    }
    .classify {
      background-image: url("~@/assets/images/life/coupon_default@2x.png");
    }
  }
  .info {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 10px 0;
    .info-l {
      margin-right: 10px;
      width: 100px;
      text-align: center;
      h3 {
        font-size: 24px;
      }
    }
    .info-c {
      flex: 1;
      font-size: 12px;
      line-height: 1.2;
      h3 {
        font-size: 14px;
        font-weight: 400;
      }
      p {
        margin-top: 5px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }
    }
  }
  .desc {
    padding: 10px 0;
    line-height: 1.2;
    border-top: 1.1px dashed #dbdbdb;
  }
}

.classify {
  display: flex;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 36px;
  height: 36px;
  text-align: center;
  font-size: 10px;
  color: #fff;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url("~@/assets/images/life/coupon_merchant@2x.png");
  &.platform {
    background-image: url("~@/assets/images/life/coupon_platform@2x.png");
  }
  img {
    width: 100%;
  }
}

.ticket {
  margin-right: 5px;
  padding: 2px 5px;
  color: #fc3c46;
  font-size: 10px;
  border: 1.1px solid #fc3c46;
  border-radius: 3px;
  &.style2 {
    color: #fe7800;
    border: 1.1px solid #fe7800;
  }
}
</style>
